<template>
  <div class="page">
    <navbar></navbar>
    <div class="content">
      <div class="no-data" v-if="appointments.length <= 0">
        <img src="../assets/not_found.svg" alt="" />
        No appointments found ...
      </div>

      <div class="appointments">
        <div
          class="appointment"
          v-for="item in appointments"
          v-bind:key="item.id"
          @click="onClickItem(item)"
        >
          <div class="detail">
            <div class="key-group">
              <img class="key" src="../assets/icons/ic_patient.png" />
              <div class="group">
                <span class="name">{{ item.name }}</span>
                <span>{{ item.phone }}</span>
                <span>{{ item.email }}</span>
              </div>
            </div>

            <div class="key-group">
              <img class="key" src="../assets/icons/ic_location.png" />
              <div class="group">
                <span>{{ item.address }}</span>
                <span>{{ item.city }}</span>
                <span>{{
                  moment(item.time).format("YYYY-MM-DD , HH:mm a")
                }}</span>
              </div>
            </div>
          </div>
          <img src="../assets/icons/ic_arrow_right.png" alt="" class="action" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
import moment from "moment";
import { parse } from "qs";
export default {
  name: "Home",
  components: {
    navbar: NavBar,
  },
  data() {
    return {
      appointments: [],
    };
  },
  methods: {
    onClickItem(item) {
      console.log(item);
      this.$router.push({
        name: "Detail",
        params: {
          appointment: JSON.stringify(item),
        },
      });
    },
    getAppointments() {
      this.$HTTP.get(this.$URLS.APPOINTMENT.LIST).then((data) => {
        var parsed = [];
        data.data.rows.forEach((item) => {
          let allCompleted = item.tests.every(
            (item) => item.status == "completed"
          );
          if (!allCompleted) {
            parsed.push(item);
          }
        });

        this.appointments = parsed;
      });
    },
  },
  created() {
    this.moment = moment;
    this.getAppointments();
  },
};
</script>

<style lang="scss" scoped>
.appointments {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #eeeeee;
  overflow: scroll;

  .appointment {
    width: 100%;
    padding: 1rem;
    border-bottom: 0.1rem solid #e0e0e0;
    background: white;
    display: flex;
    flex-direction: row;
    align-items: center;

    .detail {
      width: 100%;

      .key-group {
        width: 100%;
        display: flex;
        align-items: center;
        .key {
          width: 5rem;
          height: 5rem;
        }
        .group {
          margin-left: 1rem;
          display: flex;
          flex-direction: column;
          font-family: "P-400";
          font-size: 1.4rem;

          span {
            padding: 0.2rem;
          }
        }
        margin-bottom: 1rem;
      }

      .name {
        font-size: 1.6rem;
        color: black;
        font-family: "P-600";
      }
    }

    .action {
      width: 3rem;
      height: 3rem;
    }
  }
}
</style>